import { render, staticRenderFns } from "./FormTimeSetupStreamax.vue?vue&type=template&id=4eb7b894&scoped=true&"
import script from "./FormTimeSetupStreamax.vue?vue&type=script&lang=ts&"
export * from "./FormTimeSetupStreamax.vue?vue&type=script&lang=ts&"
import style0 from "./FormTimeSetupStreamax.vue?vue&type=style&index=0&id=4eb7b894&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb7b894",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('4eb7b894', component.options)
    } else {
      api.reload('4eb7b894', component.options)
    }
    module.hot.accept("./FormTimeSetupStreamax.vue?vue&type=template&id=4eb7b894&scoped=true&", function () {
      api.rerender('4eb7b894', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/ConfiguracionCamaras/Streamax/TimeSetup/FormTimeSetupStreamax.vue"
export default component.exports